import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class BaseBillingEntity extends BaseModel {
  /**
   * @var {number}
   */
  createdAt;

  /**
   * @var {number}
   */
  updatedAt;

  constructor(model = {}) {
    super();

    this.createdAt = model.createdAt;
    this.updatedAt = model.updatedAt;
  }
}
